import { Component, effect, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nService } from '@core/i18n';
import { ErrorPageComponent, UnauthorizedPageComponent } from '@shared/pages';
import { CurrentUserService, NavigationHistoryService } from '@shared/services';
import { CurrentUser, ToasterPositionEnum } from '@shared/types';
import { LoaderComponent } from '@ui-kit/miscs/loader/loader.component';
import { ToastModule } from 'primeng/toast';
import { BreadcrumbsComponent, FooterComponent, HeaderComponent } from './layout';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        HeaderComponent,
        BreadcrumbsComponent,
        LoaderComponent,
        RouterModule,
        ErrorPageComponent,
        UnauthorizedPageComponent,
        FooterComponent,
        ToastModule,
    ],
    standalone: true,
})
export class AppComponent {
    navHistoryService = inject(NavigationHistoryService);
    private currentUserService = inject(CurrentUserService);
    private i18nService = inject(I18nService);

    isLoading = true;
    hasError = false;
    currentUser: CurrentUser | null = null;
    toasterPositions = ToasterPositionEnum;

    isUnauthorized = false;

    constructor() {
        this.i18nService.initialize();

        effect(() => {
            this.currentUser = this.currentUserService.currentUser();
            this.isLoading = false;
        });

        effect(() => {
            this.isUnauthorized = this.currentUserService.isUnauthorized();
            this.currentUser = null;
            this.isLoading = false;
        });
    }
}
